import React from 'react'

export default () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="18" height="17.9992" rx="8.99962" fill="#F9F9F9" />
    <path
      d="M9.3125 9.18705C9.3125 9.18705 9.38108 6.27313 10.4586 5.19556C11.3256 4.32856 12.6654 4.26267 13.4511 5.04839C14.2369 5.83411 14.171 7.17388 13.304 8.0409C12.2264 9.11847 9.3125 9.18705 9.3125 9.18705Z"
      fill="url(#paint0_linear_264_1723)"
    />
    <path
      d="M8.68754 9.18704C8.68754 9.18704 8.61895 6.27312 7.54138 5.19556C6.67438 4.32856 5.33459 4.26267 4.54887 5.04839C3.76316 5.8341 3.82905 7.17387 4.69605 8.0409C5.77361 9.11846 8.68754 9.18704 8.68754 9.18704Z"
      fill="url(#paint1_linear_264_1723)"
    />
    <path
      d="M7.54113 13.8037C8.6187 12.7262 8.68728 9.81226 8.68728 9.81226C8.68728 9.81226 5.77337 9.88084 4.69581 10.9584C3.82881 11.8254 3.76292 13.1652 4.54863 13.9509C5.33435 14.7366 6.67414 14.6707 7.54113 13.8037Z"
      fill="url(#paint2_linear_264_1723)"
    />
    <path
      d="M9.31287 9.81226C9.31287 9.81226 9.38145 12.7262 10.459 13.8037C11.326 14.6707 12.6658 14.7366 13.4515 13.9509L9.31287 9.81226Z"
      fill="#FBDB30"
    />
    <path
      d="M13.4515 13.9509C14.2372 13.1652 14.1714 11.8254 13.3043 10.9584C12.2268 9.88084 9.31287 9.81226 9.31287 9.81226L13.4515 13.9509Z"
      fill="#FBDB30"
    />
    <path
      d="M9.31287 9.81226C9.31287 9.81226 9.38145 12.7262 10.459 13.8037C11.326 14.6707 12.6658 14.7366 13.4515 13.9509L9.31287 9.81226Z"
      fill="#FF5E20"
    />
    <defs>
      <linearGradient
        id="paint0_linear_264_1723"
        x1="9.3125"
        y1="9.18705"
        x2="13.4927"
        y2="5.02"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCC02D" />
        <stop offset="1" stopColor="#FCBA2C" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_264_1723"
        x1="4.29239"
        y1="4.92982"
        x2="8.68753"
        y2="9.18705"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FD9B28" />
        <stop offset="1" stopColor="#FD9F28" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_264_1723"
        x1="4.6306"
        y1="14.0852"
        x2="8.75729"
        y2="9.71049"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FE7A24" />
        <stop offset="1" stopColor="#FE7B24" />
      </linearGradient>
    </defs>
  </svg>
)
